export function GetMainPhoto(photoList) {
  // NOTE: This function returns the main photo KEY not the photo object itself
  if (!photoList) return null;

  for (let photoKey in photoList) {
    if (photoList[photoKey] == 'main' || photoList[photoKey].association == 'main') {
      return photoKey;
    }
  }

  return null;
}
